<template>
  <div class="layout-inner">
    Loading...
  </div>
</template>

<script>
  export default {
    name: 'redirectToWebWidgetVerification',
    mounted () {
      let email = this.getQueryParamByName('email')
      let verificationCode = this.getQueryParamByName('verificationCode')
      let queryParam = 'email=' + email + '&verificationCode=' + verificationCode
      window.location.href = '/frontend/#/widget/verification?' + encodeURIComponent(queryParam)
    },
    methods: {
      getQueryParamByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(decodeURIComponent(url))
        if (!results || !results[2]) return ''
        return results[2].replace(/\+/g, ' ')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/login/components/RedirectToWebWidgetVerification.vue